const videoPlayBtn = document.getElementById('hero__video-btn')
const videoThumbnail = document.getElementById('hero__video-thumbnail')
const heroImages = document.querySelectorAll('.hero__image');

if (videoPlayBtn) {
    videoPlayBtn.onclick = function (event) {
        const video = `${videoPlayBtn.getAttribute('data-src')}?autoplay=1&mute=1`
        const iframe = document.createElement('iframe')
        iframe.setAttribute('class', 'hero__video hero__video-desktop')
        iframe.setAttribute('src', video)
        document.getElementById('hero__video-wrapper').replaceChild(iframe, videoPlayBtn)
        videoThumbnail.style.display = 'none'
    }
}

if (heroImages) {
    updateAltText();

    // Add event listener to update alt text when browser is resized
    window.addEventListener('resize', debounce(updateAltText, 200));
}

// Update alt text of hero image
function updateAltText () {
    heroImages.forEach(heroImage => {
        if (window.innerWidth <= 950) {
            heroImage.setAttribute('alt', heroImage.getAttribute('data-alt-mobile'));
        } else {
            heroImage.setAttribute('alt', heroImage.getAttribute('data-alt-desktop'));
        }
    });
}

// Debounce function
function debounce (func, delay) {
    let timeout;
    return function () {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}
